// extracted by mini-css-extract-plugin
export default {"Chip":"Chip_Chip__sVKsq","closeWrap":"Chip_closeWrap__qe0di","text":"Chip_text__ovsSc","close":"Chip_close__sQrS-"};